import {CRUDDockmanagerReducer} from './patiomanager.reducer';
import * as CRUDDockmanagerAction from './patiomanager.actions'; 
import {DockmanagerFormPage} from './form/DockmanagerFormPage';
const heightBoxSchedule = 20
export { CRUDDockmanagerReducer,CRUDDockmanagerAction,DockmanagerFormPage,heightBoxSchedule};